// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"buttonItem_linkButton__bPlY7"};